module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/General/Edit-da9ddfadb99b223237f7d83b164f72dfcaa8f5e7b30dccbe357655663603f6ce.svg";